/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FilterIcon = /*#__PURE__*/ createSvgIcon(
  'FilterIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M14.5 17c-.84 0-1.55-.29-2.13-.87-.58-.58-.87-1.29-.87-2.13 0-.84.29-1.55.87-2.13.58-.58 1.29-.87 2.13-.87.84 0 1.55.29 2.13.87.58.58.87 1.29.87 2.13 0 .84-.29 1.55-.87 2.13-.58.58-1.29.87-2.13.87zm.002-1.5a1.44 1.44 0 001.06-.44c.292-.293.438-.648.438-1.063a1.44 1.44 0 00-.44-1.06 1.452 1.452 0 00-1.063-.437 1.44 1.44 0 00-1.06.44A1.452 1.452 0 0013 14.003c0 .415.147.768.44 1.06.293.291.648.437 1.063.437zm-5.252-.75h-5a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h5c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219zM5.5 9c-.84 0-1.55-.29-2.13-.87C2.79 7.55 2.5 6.84 2.5 6c0-.84.29-1.55.87-2.13C3.95 3.29 4.66 3 5.5 3c.84 0 1.55.29 2.13.87.58.58.87 1.29.87 2.13 0 .84-.29 1.55-.87 2.13-.58.58-1.29.87-2.13.87zm.003-1.5a1.44 1.44 0 001.06-.44C6.854 6.767 7 6.413 7 5.997a1.44 1.44 0 00-.44-1.06A1.452 1.452 0 005.497 4.5a1.44 1.44 0 00-1.06.44A1.452 1.452 0 004 6.003c0 .415.147.768.44 1.06.293.291.647.437 1.063.437zm10.247-.75h-5a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h5c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FilterIcon;
